import React, { useEffect, useState } from "react";
import "./BodySite.css"
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate, NavLink, Navigate } from "react-router-dom";
import PageTitles from "./PageTitles";
import CiudadanosService from "../services/CiudadanosService";
import bodySiteM from "./BodySiteM.module.css";
import { Button, Modal, ModalBody, ModalFooter, Spinner } from "reactstrap";


const TramitesCancelaView = () => {
    const navigate = useNavigate();
    const [modalDelete, setModalDelete] = useState(false);
    const [loading, setLoading] = useState(false);

    const toggleDelete = () => {
        setModalDelete(!modalDelete);
    }

    const doDeletion = () => {

       let cancelacion = {

        
            Codigo: localStorage.getItem("Cancela-Codigo"),
            FechaHoraTurno: localStorage.getItem("Cancela-FechaHora"),
            IdTurno: localStorage.getItem("Cancela-IdTurno"), 
            duracion: localStorage.getItem("Cancela-Duracion"),
            ScheduleId: localStorage.getItem("Cancela-ScheduleId"),
            BranchId: localStorage.getItem("Cancela-BranchId"), 
            DNI: localStorage.getItem("Cancela-DNI"),
            FechaNacimiento: localStorage.getItem("Cancela-FechaNacimiento")
           
       };


           
        
        CiudadanosService.cancelarTurnosCuidarnos(cancelacion)
        .then((resp)=>{
            console.log(resp);
            setLoading(false);
            navigate("/misturnoslista");
        })
        .catch((error)=>{
            console.log(error);
            setLoading(false);
        });
        setLoading(true);
    }
    
    return (
        <>
    <Modal isOpen={modalDelete} toggle={toggleDelete} modalClassName={bodySiteM.modalposDelete} contentClassName={bodySiteM.modalinfo}>
   
   <ModalBody className={bodySiteM.modalinfo}>
     <div class="row">
        <div class="col alignToLeft">
 Anular el turno?     </div>
     </div>
    
     
                 
        {loading ?  <div align="center">
   <Spinner color="light" align="center"/></div>:<></>}
   

       
   </ModalBody>
   <ModalFooter>
    <div class="col alignLeft">
   <Button  className={bodySiteM.buttonInvertedDangerMini}onClick={doDeletion}>Eliminar</Button></div>
   <div class="col alignRight">
   <Button  className={bodySiteM.buttonInvertedDangerMini}onClick={toggleDelete}>Cancelar</Button></div>
   </ModalFooter>
   
   </Modal>
       <div class="container text-center mainContent" >
        <PageTitles texto="Mis Turnos"  icono="./icon_header_turnos.svg" retorno="/misturnoslista"/>

    <div class="row">  <div class="col-2"></div>  
    <div class="col-1" style={{textAlign:"center"}}> 
    <img src="./icon-turno.svg" class="imgCancTurnoTit"/>
    </div>
    <div class="col miniTitle itemMiTurno">
    {localStorage.getItem("Cancela-Name")} </div>
    </div>
    <div class="row"><div class="col-2"></div><div class="col-1"></div>
    <div class="col-9 textGrey textLeft">
    {CiudadanosService.convertir(localStorage.getItem("Cancela-Fecha"))} - {localStorage.getItem("Cancela-Hora")} </div>
    </div>
    <div class="row"><div class="col-2"></div><div class="col-1"></div>
    <div class="col-7 textGrey  textLeft" >{localStorage.getItem("Cancela-Direccion")}</div>
    </div>
   
<div>
<div class="row" style={{paddingTop:"30px"}}>
                <div class="col">
                    <div className="buttonContainer">
                        <button className="buttonEstacionamientoClip" onClick={toggleDelete}>Anular turno</button>
                    </div>
                </div>
            </div>
            <div class="row">
            <div class="col">
                <div className="buttonContainer">
                    <button className="buttonEstacionamientoClip" onClick={() => navigate("/misturnoslista")}>Salir</button>
                </div>
            </div>
        </div>
        </div>
    </div>        
    </>
    );
    }
export default TramitesCancelaView;